import { styled, Flex } from '@grupoboticario/flora-react';

export const styles = {
  TitleWrapper: styled(Flex, {
    alignItems: 'flex-end',
    gap: '$6',
  }),
};

export default styles;
